import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

/**
 * RequireAuth — route guard. Wraps any protected route element. If the
 * cashier is not signed in, redirects to /login and remembers the
 * originally-requested path so we can bounce them back after PIN entry.
 *
 * Usage:
 *   <Route path="/pos" element={<RequireAuth><PosPage /></RequireAuth>} />
 */
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // While we're checking with the server, render nothing (avoids a
  // flash to /login on every page refresh while /me is in flight).
  if (loading) return null;

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
